import firebase from "firebase";
import "firebase/firestore";
require("dotenv").config();
export const data = firebase.firestore.FieldValue;
var config = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  // databaseURL: process.env.REACT_APP_databaseURL,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};
// Initialize Firebase
firebase.initializeApp(config);
// firebase.analytics();

export default firebase.firestore();

// REACT_APP_VIITOR=29349147-6ca3-444c-a57b-450d56e57ebf
// REACT_APP_OLIVER=ho_Gd6NvP413zmy8XM05rkwbUxBejHs7pSfQ2CZADVFJKcRugh
// REACT_APP_apiKey=AIzaSyCWpZ9RP37A-Q24WdqFQOEGFXB3DLz5I9M
// REACT_APP_authDomain=react-cloud-d6cb5.firebaseapp.com
// REACT_APP_databaseURL=https://react-cloud-d6cb5-default-rtdb.firebaseio.com
// REACT_APP_projectId=react-cloud-d6cb5
// REACT_APP_storageBucket=react-cloud-d6cb5.appspot.com
// REACT_APP_messagingSenderId=755154586271
// REACT_APP_appId=1:755154586271:web:5f9922ef8bb7f60b2bb0aa
